import React, { useEffect, useState } from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const Toast = ({ message, type = 'info', onClose, duration = 5000, id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Анимация появления
    setTimeout(() => setIsVisible(true), 10);
    
    // Автоматическое закрытие
    const autoCloseTimer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(autoCloseTimer);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose(id);
    }, 300);
  };

  const toastConfig = {
    success: {
      icon: CheckCircle,
      className: 'bg-green-50 border-green-200 text-green-800',
      iconClassName: 'text-green-600',
      progressClassName: 'bg-green-500'
    },
    error: {
      icon: AlertCircle,
      className: 'bg-red-50 border-red-200 text-red-800',
      iconClassName: 'text-red-600',
      progressClassName: 'bg-red-500'
    },
    warning: {
      icon: AlertTriangle,
      className: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      iconClassName: 'text-yellow-600',
      progressClassName: 'bg-yellow-500'
    },
    info: {
      icon: Info,
      className: 'bg-blue-50 border-blue-200 text-blue-800',
      iconClassName: 'text-blue-600',
      progressClassName: 'bg-blue-500'
    }
  };

  const config = toastConfig[type];
  const Icon = config.icon;

  return (
    <div 
      className={`
        relative flex items-start gap-3 p-4 rounded-lg border shadow-lg 
        transition-all duration-300 ease-in-out transform
        ${config.className}
        ${isVisible && !isExiting ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
        ${isExiting ? 'translate-x-full opacity-0' : ''}
        min-w-[300px] max-w-[400px] pointer-events-auto
      `}
    >
      {/* Иконка */}
      <div className={`flex-shrink-0 ${config.iconClassName}`}>
        <Icon className="w-5 h-5" />
      </div>
      
      {/* Сообщение */}
      <div className="flex-1 text-sm font-medium">
        {message}
      </div>
      
      {/* Кнопка закрыть */}
      <button
        onClick={handleClose}
        className="flex-shrink-0 hover:opacity-70 transition-opacity"
      >
        <X className="w-4 h-4" />
      </button>
      
      {/* Прогресс бар */}
      <div className="absolute bottom-0 left-0 h-1 rounded-b-lg overflow-hidden">
        <div 
          className={`h-full ${config.progressClassName} transition-all duration-100 ease-linear`}
          style={{ 
            width: isVisible && !isExiting ? '100%' : '0%',
            transitionDuration: `${duration}ms`
          }}
        />
      </div>
    </div>
  );
};

export default Toast;